import { type FC } from "react";
import { useNavigate } from "react-router-dom";

import { Button, Headline } from "@fronterahealth/frontera-ui-components";

import { PromptsTable } from "@components/Prompts/PromptsTable";

/**
 * Prompts index.
 *
 * "New Prompt" now navigates to ``/prompts/new`` — a full-page setup
 * form (not a modal). That page collects the minimum Prompt-row fields
 * (key + name + org), creates the row, and hands off to
 * ``/prompts/<key>/evaluations`` where the user drafts the rest of
 * the yaml (instructions, inputs, technical instructions, sample
 * output, response schema) and runs tests before opening the
 * pipelines PR via ``Review draft →``.
 */
export const Prompts: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-full">
      <div className="flex items-end justify-between px-16 pb-4 pt-8 shrink-0">
        <Headline size="medium">Prompts</Headline>
        <div className="flex items-center gap-4">
          <Button
            text="New Prompt"
            appearance="primary"
            className="rounded-sm"
            onClick={() => navigate("/prompts/new")}
          />
        </div>
      </div>
      <div className="px-16 w-full overflow-hidden">
        <PromptsTable />
      </div>
    </div>
  );
};
